import * as React from "react";
import { useDrag } from 'react-dnd';
import {ItemTypes} from '../Dropable';
import {
  actionCreators,
} from "../NewTaskForm/action";
import { connect } from "react-redux";
import {CATEGORY} from '../TasksList/constants';
import { PRIORITY } from './constant';


const style = {

  }

  const isPriority = (dropResultName) => dropResultName===PRIORITY;
  const isAction = (dropResultName) => dropResultName===CATEGORY.NEXT || dropResultName===CATEGORY.WAITING || dropResultName===CATEGORY.SCHEDULED || dropResultName===CATEGORY.SOMEDAY;
  const isInbox = (dropResultName) => dropResultName===null;
  const isFocus = (dropResultName) => dropResultName===CATEGORY.FOCUS;
  const isProject = (dropResultName) => !isAction(dropResultName) && !isInbox(dropResultName) && !isFocus(dropResultName);


  const Draggable = ({ taskId, children, saveTask, priority }) => {
    const [{ isDragging }, drag] = useDrag({
      item: { taskId, type: ItemTypes.BOX, priority },
      end: (item, monitor) => {

        const dropResult = monitor.getDropResult()
        if (item && dropResult) {
          //alert(`You dropped ${item.taskId} into ${dropResult.name}, ${dropResult.action}!`);

          const saveObject = 
          isPriority(dropResult.name) ?  {
            id: item.taskId, 
            priority: dropResult.priority+1, 
            action: dropResult.action,
            done: dropResult.done
          }
          : isAction(dropResult.name) ?
           {
              id: item.taskId, 
              action: dropResult.name
            }
          : isInbox(dropResult.name) ? 
          {
            id: item.taskId, 
            action: "",
            focus: false,
            parent: ""
          }: isFocus(dropResult.name) ? {
            id: item.taskId, 
            focus: true,
          } : isProject(dropResult.name) ? {    
            id: item.taskId, 
            parent: dropResult.name
          }: {}

     
          saveTask(saveObject);
        }
      },
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
    })
    const opacity = isDragging ? 0.4 : 1
    return (<> 
     
      <div ref={drag} style={{ ...style, opacity }}>
        {children}
      </div>
       
      </>
    )
  }

  // const mapStateToProps = state => ({
  //   test: state.test
  // });
  
  export default connect(null, actionCreators)(Draggable);